import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import classNames from 'classnames';
import PDPNameSectionPlaceholder from './PDPNameSection/PDPNameSectionPlaceholder';
import PDPShopTabsBarPlaceholder from './PDPShopTabsBar/PDPShopTabsBarPlaceholder';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptions/PDPChooseYourOptionsPlaceholder';
import PDPProtectionPlanSelectorPlaceholder from './PDPProtectionPlanSelector/PDPProtectionPlanSelectorPlaceholder';
import PDPAddToBagSectionPlaceholder from './PDPAddToBagSection/PDPAddToBagSectionPlaceholder';
import buildPdpDesktopHeroLcpUrl from './PDPDesktopHeroGallery/helpers/buildPdpDesktopHeroLcpUrl';

/**
 * Context-region Suspense fallback: section placeholders for the rail, and the
 * resolved server hero image (when available) so LCP can paint without waiting
 * on basicDetails / stock / protection / options.
 */
const PDPContextRegionPlaceholder = t0 => {
  const $ = _c(28);
  const {
    productHeroImage: t1,
    productCylindoHeroImage: t2,
    className: parentClassName
  } = t0;
  const productHeroImage = t1 === undefined ? null : t1;
  const productCylindoHeroImage = t2 === undefined ? null : t2;
  const desktopHeroSrc = productHeroImage?.src || productCylindoHeroImage?.src || null;
  let t3;
  if ($[0] !== desktopHeroSrc) {
    t3 = desktopHeroSrc ? buildPdpDesktopHeroLcpUrl(desktopHeroSrc) ?? desktopHeroSrc : null;
    $[0] = desktopHeroSrc;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const desktopHeroHref = t3;
  const desktopHeroAlt = productHeroImage?.alt || productCylindoHeroImage?.alt || "";
  const mobileHeroSrc = productHeroImage?.src || productCylindoHeroImage?.src || null;
  const mobileHeroAlt = productHeroImage?.alt || productCylindoHeroImage?.alt || "";
  let t4;
  if ($[2] !== parentClassName) {
    t4 = classNames("hidden lg:flex mx-auto my-0 py-0 flex-row-reverse !pt-2 !pb-8 px-5 md:px-[3.333vw] min-[1500px]:px-[50px] max-w-[1800px]", parentClassName);
    $[2] = parentClassName;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]"><PDPNameSectionPlaceholder /><PDPShopTabsBarPlaceholder /><PDPChooseYourOptionsPlaceholder /><PDPProtectionPlanSelectorPlaceholder /><PDPAddToBagSectionPlaceholder /></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== desktopHeroAlt || $[6] !== desktopHeroHref || $[7] !== productHeroImage?.height || $[8] !== productHeroImage?.width) {
    t6 = <div className="flex-1 mr-12"><div className="sticky top-8"><div className="mb-8 flex flex-col items-center relative max-w-[calc((100vh - 194px) / 0.6666666666666666)]">{desktopHeroHref ? <img className="h-full w-full object-contain object-center select-none" src={desktopHeroHref} alt={desktopHeroAlt} width={productHeroImage?.width || 1600} height={productHeroImage?.height || 2400} loading="eager" fetchPriority="high" decoding="async" style={{
            width: "50vw",
            height: "70vh",
            objectFit: "contain"
          }} /> : <Placeholder loading={true} type="rect" style={{
            width: "50vw",
            height: "70vh",
            margin: "none"
          }} />}</div></div></div>;
    $[5] = desktopHeroAlt;
    $[6] = desktopHeroHref;
    $[7] = productHeroImage?.height;
    $[8] = productHeroImage?.width;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className={t4} data-xc="PDPContextRegionPlaceholder-desktop">{t5}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== parentClassName) {
    t8 = classNames("flex flex-col lg:hidden", parentClassName);
    $[13] = parentClassName;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]"><PDPNameSectionPlaceholder /></div>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== mobileHeroAlt || $[17] !== mobileHeroSrc || $[18] !== productHeroImage?.height || $[19] !== productHeroImage?.width) {
    t10 = mobileHeroSrc ? <img className="mb-1.5 w-full object-contain object-center" src={mobileHeroSrc} alt={mobileHeroAlt} width={productHeroImage?.width || 800} height={productHeroImage?.height || 800} loading="eager" fetchPriority="high" decoding="async" style={{
      width: "100vw",
      aspectRatio: "1/1",
      objectFit: "contain"
    }} /> : <Placeholder className="mb-1.5" loading={true} type="rect" style={{
      width: "100vw",
      aspectRatio: "1/1"
    }} />;
    $[16] = mobileHeroAlt;
    $[17] = mobileHeroSrc;
    $[18] = productHeroImage?.height;
    $[19] = productHeroImage?.width;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]"><PDPChooseYourOptionsPlaceholder /><PDPProtectionPlanSelectorPlaceholder /><PDPAddToBagSectionPlaceholder /></div>;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t8) {
    t12 = <div className={t8} data-xc="PDPContextRegionPlaceholder-mobile">{t9}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t7) {
    t13 = <>{t7}{t12}</>;
    $[25] = t12;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
PDPContextRegionPlaceholder.propTypes = {
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  className: PropTypes.string
};
export default PDPContextRegionPlaceholder;